import adminApi from "api/endpoints/Admin";
import bookingApi from "api/endpoints/Booking";
import buyerApi from "api/endpoints/Buyers";
import marketplaceApi from "api/endpoints/Marketplace";
import offerApi from "api/endpoints/Offers";
import orderApi from "api/endpoints/Order";
import organizationApi from "api/endpoints/Organizations";
import parcelApi from "api/endpoints/Parcel";
import projectApi from "api/endpoints/Project";
import userApi from "api/endpoints/User";

const apisService = {
  admin: adminApi,
  booking: bookingApi,
  buyer: buyerApi,
  marketplace: marketplaceApi,
  offer: offerApi,
  order: orderApi,
  organization: organizationApi,
  parcel: parcelApi,
  project: projectApi,
  user: userApi,
};

export default apisService;
